module.exports = __webpack_public_path__ + "static/media/backpack.ad6cd18b.svg";